import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles/globals.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import StatsBar from './components/StatsBar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AdminPage from './components/AdminPage';

const Services = lazy(() => import("./components/Services"));
const SolarInstallation = lazy(() => import("./components/SolarInstallation"));
const SolarPark = lazy(() => import("./components/SolarPark"));
const BatteryStorage = lazy(() => import("./components/BatteryStorage"));
const About = lazy(() => import("./components/About"));
const Differentiators = lazy(() => import("./components/Differentiators"));
const SurveyForm = lazy(() => import("./components/SurveyForm"));
const Contact = lazy(() => import("./components/Contact"));

function HomePage() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <Suspense fallback={null}>
          <Services />
          <SolarInstallation />
          <SolarPark />
          <BatteryStorage />
          <About />
          <Differentiators />
          <SurveyForm />
          <Contact />
        </Suspense>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
